import BaseModel from './BaseModel';

/** Class representing a message. */
class Message extends BaseModel {}

export default Message;
